import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCreditNote } from "../services/creditNoteService";
import jsPDF from "jspdf";

const CreditNoteDetailPage = () => {
  const { id } = useParams();
  const [creditNote, setCreditNote] = useState(null);

  useEffect(() => {
    getCreditNote(id).then(setCreditNote);
  }, [id]);

  const handlePreviewPDF = () => {
    const doc = new jsPDF({ format: "a4", unit: "px", orientation: "portrait" });
    doc.text("Credit Note PDF Preview", 20, 20);
    doc.save("creditnote.pdf");
  };

  if (!creditNote) return <div>Loading...</div>;

  return (
    <div>
      <h2 style={{ fontSize: 22, color: "#1976d2", marginBottom: 12, fontWeight: 600 }}>
        Credit Note Details
      </h2>
      <div>
        <strong>Credit Note #:</strong> {creditNote.CreditNoteNumber}
      </div>
      <div>
        <strong>Customer:</strong> {creditNote.CustomerName}
      </div>
      <div>
        <strong>Notes:</strong> {creditNote.Notes}
      </div>
      <div>
        <strong>Line Items:</strong>
        <ul>
          {creditNote.LineItems.map(item => (
            <li key={item.Id}>
              Product: {item.ProductId}, Qty: {item.Quantity}, Price: {item.UnitPrice}, VAT: {item.VATPercent}%
            </li>
          ))}
        </ul>
      </div>
      <button
        onClick={handlePreviewPDF}
        style={{
          marginTop: 24,
          background: "#1976d2",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "10px 24px",
          fontWeight: 700,
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        Preview PDF
      </button>
    </div>
  );
};

export default CreditNoteDetailPage;